import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

function RequestResetPassword() {
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (data.get('email').length === 0) {
        setEmailError(true);
    }
    else {
        axios.post('/api/forgotpassword',
            {
                email: data.get('email'),
            }).then(function (response) {
            // console.log(response);
            if (response.status === 200) {
                // console.log(response);
                // Flash Success somehow
                navigate('/');
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.response.status === 401) {
                console.log('request failed');
                setEmailError(true);
            }
        });
    }
  }

  return (
      <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <h2>RCP RGA Portal</h2>
          <Typography component="h1" variant="h5">
            Request Reset Password
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
              margin="normal"
              required
              fullWidth
              error={emailError}
              id=""
              label="Email Address"
              name="email"
              helperText={emailError ? "This email is not valid for password reset." : ""}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Request Reset
            </Button>
          </Box>
      </Box>
  );
}

export default RequestResetPassword;